/**
 * Internal-testing override for the AI cancellation chat: landing on the portal
 * with ?so_cancel_chat=1 (or =true) forces the chat regardless of the runtime
 * rollout percentage, so the team can test in production while real customers
 * (rollout at 0) keep the legacy dialog. The override sticks in sessionStorage
 * for the rest of the tab session so in-portal navigation doesn't drop it.
 *
 * Overridden sessions are stamped cancel_flow_variant="forced" (see
 * ManageSubscriptionSheet), keeping internal traffic out of both A/B arms.
 */

const OVERRIDE_STORAGE_KEY = "so_cancel_chat_override";

export function parseCancelChatOverrideParam(search: string): boolean {
  const value = new URLSearchParams(search).get("so_cancel_chat");
  return value === "1" || value === "true";
}

export function hasCancelChatOverride(): boolean {
  if (typeof window === "undefined") return false;
  try {
    if (parseCancelChatOverrideParam(window.location.search)) {
      sessionStorage.setItem(OVERRIDE_STORAGE_KEY, "1");
      return true;
    }
    return sessionStorage.getItem(OVERRIDE_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}
